import ReactDOM from 'react-dom/client';
import { JobPosting } from './IJobs';
import { JobsPage }  from './Jobs';

import '~/styles/main.scss';

interface WindowWithData extends Window {
  data: JobPosting[];
}

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

const data: JobPosting[] = (window as unknown as WindowWithData).data || [];

root.render(<JobsPage data={data} />);
